import { ShortsworksChart } from "../../../chart/ShortsworksChart";

interface DetailChartProps {
  name: string;
  data: any;
  format?: string;
}

export const DetailChartSection = ({
  name,
  data,
  format,
}: DetailChartProps) => {
  return (
    <div className="p-1 bg-white border border-gray-200 min-h-20 flex-auto">
      <ShortsworksChart
        format={format}
        chartId={name}
        chartType="line"
        interval="day"
        data={data}
      />
    </div>
  );
};
